import { View } from "@/components/ui/view";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Platform } from 'react-native';
import { FlatList, RefreshControl } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSelector, useDispatch } from "react-redux";
import i18n from '@/assets/i18n';
import Footer from "@/components/basic/Footer";
import WorkflowListElement from '@/components/workflow/WorkflowListElement';
import { switchScreen } from '@/hooks/navigate';
import { backendRequest } from '@/stores/thunks';
import InAInfo from '@/components/basic/InAInfo';

export default function PublicWorkflows({ navigation, route }) {
    const { isEdit } = route.params

    const insets = useSafeAreaInsets();
    const server = useSelector((state) => state.server)
    const user = useSelector((state) => state.user)
    const workflows = useSelector((state) => state.workflows)
    const wfMap = useSelector((state) => state.wfMap || [])
    const published = useSelector((state) => state.published || [])
    const dispatch = useDispatch()

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: isEdit ? 'PublicWorkflows' : 'BACK', params: { isEdit: false } },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: '' }
    ]

    const data = !isEdit ? published.filter(share => wfMap[share.workflow.id]) :
        Object.keys(workflows)
            .filter(taskid => taskid.length > 2 && !workflows[taskid].deleted && workflows[taskid].owned && !published.find(share => workflows[taskid].workflowId == share.workflow.id))

    useEffect(() => {
        navigation.setOptions({ info: i18n.t(isEdit ? 'shareQRCode.infoNeu' : 'shareQRCode.info'), showMoreOptionsMenu: !isEdit })
        if (!isEdit) {
            dispatch(backendRequest('GET_CONTACTS_INLINE', '/contact/user', null, 'GET', false))
        }
    }, [isEdit])

    const onPress = (taskid) => {
        switchScreen(navigation, 'ShareQRCode', { task: workflows[taskid], isEdit: isEdit })
    }

    const newShare = () => {
        switchScreen(navigation, 'PublicWorkflows', { isEdit: true })
    }

    const renderItem = ({ item, index }) => {
        return item.sharedWith ?
            <WorkflowListElement navigation={navigation} taskid={wfMap[item.workflow.id]} avatar={item.image?.id || user.id} showProgress={false} showTimer={false} onPress={onPress} info={i18n.t('shareQRCode.used', { num: item.sharedWith.length })} /> :
            <WorkflowListElement navigation={navigation} taskid={item} showProgress={false} showTimer={false} onPress={onPress} />
    }

    const [refreshing, setRefreshing] = useState(false);
    const refreshRef = useRef(null);

    const onRefresh = useCallback(() => {
        if (!user.demo) {
            setRefreshing(true);
            dispatch(backendRequest('GET_CONTACTS_INLINE', '/contact/user', null, 'GET', false)).then(result => {
                setRefreshing(false);
            })
        }
    }, []);

    const refreshProps = server.online && Platform.OS !== 'web' ?
        {
            waitFor: refreshRef,
            refreshControl:
                <RefreshControl
                    ref={refreshRef}
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                    enabled={true}
                />
        } : {}
    return (
        <View className="bg-secondary-50 flex-1">
            {data.length == 0 ? <InAInfo asHint={true} info={i18n.t('shareQRCode.nothingPubliclyShared')} pose={5} /> :
                <FlatList
                    contentContainerStyle={{ paddingBottom: (server.online ? 120 : 90) + insets.bottom }}
                    data={data}
                    renderItem={renderItem}
                    keyExtractor={(item, index) => item.id || 'T' + index}
                    {...refreshProps}
                />
            }
            <Footer navigation={navigation} actions={actions} button={!isEdit && server.online ? { action: newShare, info: 'shareQRCode.button' } : null} />
        </View>
    );
}
